export const capitalizeFirstLetterOfString = (str: string) => `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`

export const capitalizeFirstLetterOfStrings = (arr: string[]) => arr.map((x) => capitalizeFirstLetterOfString(x))
